/**
 * Versões vigentes dos textos legais. Mudou o texto de forma relevante, mude a
 * versão: o aceite gravado em consentimentos_lgpd aponta para ela.
 */
export const VERSAO_TERMOS = '2026-10-12';
export const VERSAO_PRIVACIDADE = '2026-10-12';

/*
 * Identificação do controlador (LGPD art. 9º, III). Preencher antes de
 * divulgar: hoje o produto não tem razão social nem encarregado nomeados.
 */
export const CONTROLADOR = {
  razaoSocial: '[RAZÃO SOCIAL]',
  cnpj: '[CNPJ]',
  endereco: '[ENDEREÇO DA SEDE]',
  foro: '[CIDADE/UF DA SEDE]',
  emailContato: 'contato@chamaum.app',
  encarregado: '[NOME DO ENCARREGADO]',
  emailPrivacidade: 'privacidade@chamaum.app',
} as const;

/** '2026-10-02' → '2 de outubro de 2026'. */
export function dataLegal(versao: string): string {
  const [a, m, d] = versao.split('-').map(Number);
  return new Date(Date.UTC(a!, m! - 1, d!)).toLocaleDateString('pt-BR', {
    day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC',
  });
}
